// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__v+wVx","p":"Sidebar_p__lbkkh","button":"Sidebar_button__q5Qu4","selected":"Sidebar_selected__rQwO2","league":"Sidebar_league__I6jNM"};